import type { Locales } from '@crehana/i18n';
import type { GetServerSideProps } from 'next';

import { initializeApollo } from '@/shared/libs/apollo';
import { getI18nData } from '@/shared/utils/getI18n/getI18n';

const getServerSideI18nProps =
  ({
    pageKey,
    translations,
  }: {
    pageKey: string;
    translations: Record<string, Locales>;
  }): GetServerSideProps =>
  async ({ req, query }) => {
    const { slug } = query as { slug: string };
    const apolloClient = initializeApollo({
      headers: req.headers,
      pageKey,
    });

    const i18nData = await getI18nData({
      apolloClient,
      headers: req.headers,
      pageKey,
      defaultTranslations: {
        es: { [pageKey]: translations.es },
        pt: { [pageKey]: translations.pt },
        en: { [pageKey]: translations.en },
      },
    });

    return {
      props: {
        initializeApollo: apolloClient.cache.extract(),
        ...i18nData,
        organizationSlug: slug || null,
      },
    };
  };

export default getServerSideI18nProps;
